import React from "react";
import close from "../../../../assets/img/icons/Vector copy.svg";
import { Slider } from "antd";
import Button from "../../../shared/Button";

const CostInDays = ({
  firstvalue,
  secvalue,
  setfirstvalue,
  setsecvalue,
  closeModal
}) => {
  const removefilter = ()=>{
    setfirstvalue(0)
    setsecvalue(500000)
    closeModal()
  }
  return (
    <div className="ModalBackground CostInDays">
      <div className="ModalBackground--container p-[25px]">
        <div className="flex justify-between  items-center">
          <h2 className="text-[#292D32] text-[20px] font-[700]">
          محدوده قیمت
          </h2>
          <button onClick={closeModal}>
            <img src={close} />
          </button>
        </div>
        <hr className="my-[20px] " />
        <div className="center text-[18px] text-[#797D82] mb-[20px]">
          <span className="text-[#292D32]">{firstvalue}</span>{" "}
          <span className="mx-[4px]">تا</span>{" "}
          <span className=" text-[#292D32] ">{secvalue}</span>
        </div>
        <div className="ml-[20px]">
          <Slider
            step={500}
            range
            defaultValue={[firstvalue, secvalue]}
            max={500000}
            min={0}
            onChange={value => setfirstvalue(value[0])}
            onAfterChange={value => setsecvalue(value[1])}
          />
        </div>
        <div className="flex gap-[12px] mt-[45px]">
          <Button varient="white" fullwidth onClick={removefilter}>
            {" "}حذف فیلتر
          </Button>
          <Button varient="primary" fullwidth onClick={closeModal}>
            تایید محدوده قیمت
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CostInDays;
